import { Component } from '@angular/core';

/**
 * Full-screen placeholder shown instead of the normal app content when
 * RemoteConfigService.maintenanceMode is true (both builds - see
 * AppComponent.ngOnInit). Intentionally plain, doesn't need to match the
 * existing design system pixel-for-pixel.
 */
@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent {}
